<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

    export default {
        name: 'App',
        components: {},
        created() {
        },
        methods: {}
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
    }

    html, body {
        width: 100%;
        height: 100%;
        background-color: #EEF0F5;
    }

    #app {
        height: 100%;
    }

</style>
